/**
 * There's no dedicated endpoint for updating a hub, so we use the project endpoint.
 * Hubs have this prefix in their name to avoid collisions with other projects.
 * Otherwise you'd get "duplicate name" error for hubs and there would be no hub with that name.
 */
const hubNamePrefix = '_Hub: '

/**
 * Strips the hub prefix from a project name
 */
export function projectNameToHubName(name: string) {
  if (name.startsWith(hubNamePrefix)) {
    return name.slice(hubNamePrefix.length)
  }
  return hubNamePrefix + name
}

/**
 * Adds the hub prefix to a project name
 */
export function hubNameToProjectName(name: string) {
  return hubNamePrefix + name
}
